// removed by extract-text-webpack-plugin
module.exports = {"header":"hya8bSQVxtMf9bswgFOEA","btn_view_mode":"_99rCzKJRkcSYuPziXCPqA","active":"_1ZEdozoXDBFtJnjBlhvTAb","filter_type":"_2XgXnHpfj7YTuLhj-FjeZm","list_status_right":"_2ToD0YSToVQS7Svju93cjE","active_status":"_1IBDfackqexI8j6OmI8Eqe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Include/header.css
// module id = 3023
// module chunks = 0